/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_billing_and_shipping_information = /** @type {(inputs: {}) => string} */ () => {
	return `Fakturační a přepravní údaje`
};

const da_billing_and_shipping_information = /** @type {(inputs: {}) => string} */ () => {
	return `Fakturerings- og leveringsoplysninger`
};

const de_billing_and_shipping_information = /** @type {(inputs: {}) => string} */ () => {
	return `Rechnungs- und Versandinformationen`
};

const en_billing_and_shipping_information = /** @type {(inputs: {}) => string} */ () => {
	return `Billing and shipping information`
};

const es_billing_and_shipping_information = /** @type {(inputs: {}) => string} */ () => {
	return `Información de facturación y envío`
};

const fr_billing_and_shipping_information = /** @type {(inputs: {}) => string} */ () => {
	return `Informations de facturation et de livraison`
};

const hu_billing_and_shipping_information = /** @type {(inputs: {}) => string} */ () => {
	return `Számlázási és szállítási adatok`
};

const it_billing_and_shipping_information = /** @type {(inputs: {}) => string} */ () => {
	return `Informazioni di fatturazione e spedizione`
};

const nl_billing_and_shipping_information = /** @type {(inputs: {}) => string} */ () => {
	return `Facturatie- en verzendgegevens`
};

const pl_billing_and_shipping_information = /** @type {(inputs: {}) => string} */ () => {
	return `Dane do faktury i wysyłki`
};

const pt_billing_and_shipping_information = /** @type {(inputs: {}) => string} */ () => {
	return `Informações de faturamento e envio`
};

const sv_billing_and_shipping_information = /** @type {(inputs: {}) => string} */ () => {
	return `Fakturerings- och leveransinformation`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const billing_and_shipping_information = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.billing_and_shipping_information(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("billing_and_shipping_information", locale)
	if (locale === "cs") return cs_billing_and_shipping_information(inputs)
	if (locale === "da") return da_billing_and_shipping_information(inputs)
	if (locale === "de") return de_billing_and_shipping_information(inputs)
	if (locale === "en") return en_billing_and_shipping_information(inputs)
	if (locale === "es") return es_billing_and_shipping_information(inputs)
	if (locale === "fr") return fr_billing_and_shipping_information(inputs)
	if (locale === "hu") return hu_billing_and_shipping_information(inputs)
	if (locale === "it") return it_billing_and_shipping_information(inputs)
	if (locale === "nl") return nl_billing_and_shipping_information(inputs)
	if (locale === "pl") return pl_billing_and_shipping_information(inputs)
	if (locale === "pt") return pt_billing_and_shipping_information(inputs)
	return sv_billing_and_shipping_information(inputs)
};